export enum ProductType {
	Vod = 'vod',
	Packet = 'packet',
	Channel = 'channel',
	Program = 'program',
	Banner = 'banner'
}

export enum PacketSubtype {
	Main = 'main',
	Premium = 'premium',
	Provision = 'provision'
}

export type VodSubtype = 'vod' | 'series' | 'season' | 'episode';

export type ProductSubtype = PacketSubtype | VodSubtype;

export type Genre = {
	id: number;
	name: string;
	order: number | null;
	slug: string | null;
};

export enum MetadataListType {
	Text = 'TEXT',
	Icon = 'ICON',
	Hidden = 'HIDDEN'
}

export type Credits = {
	name: string;
	icon: string | null;
	role: string;
};

export type MetadataList = {
	type: MetadataListType;
	value: string;
};

export type ExtendedInfo = {
	credits: Credits[];
	metadata_lists: MetadataList[][];
};

export type AvailableIn = string[] | null;
